import React, { useEffect } from "react";
import { useStores } from "../../store";
import { useRef } from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { Observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import Loader from "../reusble_components/loader";

export default function LearningModule() {
  const navigate = useNavigate();
  const { LearningStore } = useStores();

  useEffect(() => {
    console.log("refresh");
    // LearningStore.setCurrentSubTopicById(getTheQueryFromUrl("topic"));
  }, []);
  const nextSubTopic = LearningStore.getNextSubTopicById(
    LearningStore?.currentSubTopic?._id
  );
  const prevSubTopic = LearningStore.getPrevSubTopicById(
    LearningStore?.currentSubTopic?._id
  );
  const completeTheTopic = () => {
    LearningStore.completeCurrentSubTopic();
  };

  const h1Ref = useRef(null);

  const scrollToTop = () => {
    if (h1Ref.current) {
      h1Ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Observer>
        {() => (
          <div className="bg-gray-100 min-h-screen py-8" ref={h1Ref}>
            <Loader loader={LearningStore?.loading} />
            <div className="container mx-auto px-4 relative">
              <h1 className="text-2xl font-bold mb-4">
                {LearningStore?.currentSubTopic?.title}
              </h1>

              {/* Embedded YouTube video */}

              <iframe
                //   width="560"
                //   height="315"
                src={`https://www.youtube.com/embed/${LearningStore?.currentSubTopic?.videoLink}&amp;start=0`}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowfullscreen
                className="md:w-[860px] md:h-[515px] w-[90vw] h-[30vh] rounded-[15px] lg:w-[1260px] lg:h-[815px]"></iframe>

              <p className="my-4">
                {LearningStore?.currentSubTopic?.description}
              </p>
              {LearningStore.checkTopicCompleted(
                LearningStore?.currentCourse?._id,
                LearningStore?.currentSubTopic?._id
              ) ? (
                <div
                  class="bg-green-100 border-l-4 border-green-500 text-text_color3 py-2 px-4 mb-[10vh] "
                  role="success">
                  <p class="font-bold">This topic is completed</p>
                </div>
              ) : (
                <div className="mb-[10vh]" />
                // <button
                //   class="bg-transparent hover:bg-primary text-primary mb-[10vh] font-semibold hover:text-bg3 py-2 px-4 border border-primary hover:border-transparent rounded"
                //   onClick={() => completeTheTopic()}
                // >
                //   Mark this topic as completed
                // </button>
              )}
              {LearningStore.checkShallWeMarkThisTopicAsCompleted(
                LearningStore.currentCourse?._id
              ) &&
              !LearningStore.checkTopicCompleted(
                LearningStore?.currentCourse?._id,
                LearningStore?.currentSubTopic?._id
              ) ? (
                <button
                  class="bg-transparent hover:bg-primary text-primary mb-[10vh] text-xs hover:text-bg3 py-2 px-4 border border-primary hover:border-transparent rounded"
                  onClick={
                    () =>
                      LearningStore.completeCurrentSubTopic(
                        LearningStore.currentSubTopic?._id
                      )
                    // the method will mark this topic as completed
                  }>
                  Mark this topic as completed
                </button>
              ) : null}

              {/* Navigation buttons */}

              <div className="w-[90%] mx-auto z-50 pb-5 flex justify-between items-center">
                <div className="flex flex-col">
                  <button
                    onClick={() => {
                      // if (
                      //   !LearningStore.checkTopicCompleted(
                      //     LearningStore?.currentCourse?._id,
                      //     LearningStore?.currentSubTopic?._id
                      //   )
                      // ) {
                      //   LearningStore.completeCurrentSubTopic(
                      //     LearningStore.currentSubTopic?._id
                      //   );
                      // }
                      scrollToTop();
                      LearningStore.setCurrentSubTopicById(prevSubTopic?._id);
                      if (window.innerWidth < 768) {
                        navigate(
                          `/course/${LearningStore?.currentCourse?._id}?topic=${prevSubTopic?._id}`
                        );
                      } else {
                        navigate(
                          `/dashboard/course/${LearningStore?.currentCourse?._id}?topic=${prevSubTopic?._id}`
                        );
                      }
                    }}
                    className="flex items-center text-primary hover:text-blue-600 focus:outline-none">
                    <FiArrowLeft className="text-xl mr-2" />
                    Previous
                  </button>
                  <p className="text-sm opacity-50 truncate md:w-full lg:w-full w-20 text-left">
                    {prevSubTopic?.title}
                  </p>
                </div>
                {/* {LearningStore.checkTopicCompleted(
                  LearningStore?.currentCourse?._id,
                  LearningStore?.currentSubTopic?._id
                ) ? (
                  <div
                    class="bg-green-100 border-l-4 border-green-500 text-text_color3 py-2 px-4"
                    role="success"
                  >
                    <p class="font-bold">This topic is completed</p>
                  </div>
                ) : (
                  <button
                    class="bg-transparent hover:bg-primary text-blue-700 font-semibold hover:text-bg3 py-2 px-4 border border-blue-500 hover:border-transparent rounded"
                    onClick={() => completeTheTopic()}
                  >
                    Mark this topic as completed
                  </button>
                )} */}

                <div className="flex flex-col">
                  <button
                    onClick={() => {
                      // if (
                      //   !LearningStore.checkTopicCompleted(
                      //     LearningStore?.currentCourse?._id,
                      //     LearningStore?.currentSubTopic?._id
                      //   )
                      // ) {
                      //   LearningStore.completeCurrentSubTopic(
                      //     LearningStore.currentSubTopic?._id
                      //   );
                      // }
                      scrollToTop();
                      LearningStore.setCurrentSubTopicById(nextSubTopic?._id);
                      if (window.innerWidth < 768) {
                        navigate(
                          `/course/${LearningStore?.currentCourse?._id}?topic=${nextSubTopic?._id}`
                        );
                      } else {
                        navigate(
                          `/dashboard/course/${LearningStore?.currentCourse?._id}?topic=${nextSubTopic?._id}`
                        );
                      }
                    }}
                    className="flex items-center text-primary hover:text-blue-600  focus:outline-none">
                    Next
                    <FiArrowRight className="text-xl ml-2 " />
                  </button>
                  <p className="text-sm opacity-50 truncate md:w-full lg:w-full w-20 text-right">
                    {nextSubTopic?.title}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </Observer>
    </>
  );
}
